import QueryString from "query-string";

export function createUrl(args) {
    return args ? `/${args.join("/")}/` : null;
}

export function getDataFromQueryString (type){
    const searchParams = QueryString.parse(window.location.search);
    switch (type) {
    case "ordering" : return searchParams.ordering;
    case "onboarding_id" :return searchParams.onboarding_id;
    case "dealer_name" : return searchParams.dealer_name;
    case "stage" : return searchParams.stage;
    default :
    }
} 